export default {"src":"/_next/static/media/cta-qr-app-bar.2aebbf39.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};